{
  "about": {
    "imprint": "about.imprint",
    "partner": "about.partner",
    "privacy": "about.privacy",
    "tos": "about.tos"
  },
  "acl": {
    "not-omni": ""
  },
  "app": {
    "about": "app.about",
    "title": "app.title"
  },
  "applications": {
    "accessGrantedOrganizations": "",
    "accessGrantedProfiles": "",
    "addLicensedOrganization": "",
    "clientId": "",
    "create": "",
    "edit": "",
    "licensedOrganization": {
      "notAfter": "",
      "notBefore": ""
    },
    "licensedOrganizations": "",
    "licensedOrganizationsCount": "",
    "name": "",
    "uri": "applications.uri"
  },
  "auth": {
    "change-profile": "",
    "login": "",
    "logout": "auth.logout",
    "other-account": ""
  },
  "authClients": {
    "clientId": "",
    "clientName": "authClients.clientName",
    "clientSecret": "authClients.clientSecret",
    "create": "",
    "edit": "",
    "grantTypes": "",
    "postLogoutRedirectUris": "",
    "redirectUris": "",
    "responseTypes": "",
    "scope": "",
    "tokenEndpointAuthMethod": ""
  },
  "BP aktivieren": "BP aktivieren",
  "BP deaktivieren": "BP deaktivieren",
  "change password": "",
  "common": {
    "about": "common.about",
    "add": "",
    "app-about": "",
    "app-title": "",
    "cancel": "",
    "confirm": "common.confirm",
    "dbErrorToastText": "common.dbErrorToastText",
    "delete": "",
    "deleteType": "",
    "disconnect": "",
    "errorToastText": "common.errorToastText",
    "save": "common.save",
    "select": {
      "organization": ""
    },
    "successCreateToastText_one": "common.successCreateToastText",
    "successCreateToastText_many": "common.successCreateToastText",
    "successCreateToastText_other": "common.successCreateToastText",
    "successDeleteToastText_one": "common.successDeleteToastText",
    "successDeleteToastText_many": "common.successDeleteToastText",
    "successDeleteToastText_other": "common.successDeleteToastText",
    "successDuplicateToastText_one": "common.successDuplicateToastText",
    "successDuplicateToastText_many": "common.successDuplicateToastText",
    "successDuplicateToastText_other": "common.successDuplicateToastText",
    "successSaveToastText_one": "common.successSaveToastText",
    "successSaveToastText_many": "common.successSaveToastText",
    "successSaveToastText_other": "common.successSaveToastText",
    "successToastText": "common.successToastText",
    "successUpdateToastText_one": "common.successUpdateToastText",
    "successUpdateToastText_many": "common.successUpdateToastText",
    "successUpdateToastText_other": "common.successUpdateToastText"
  },
  "dashboard": {
    "title": ""
  },
  "delete": {
    "abort": "",
    "confirm": "delete.confirm",
    "confirmText": "",
    "title": ""
  },
  "federatedClients": {
    "clientId": "federatedClients.clientId",
    "clientSecret": "federatedClients.clientSecret",
    "issuer": "federatedClients.issuer",
    "responseTypes": "federatedClients.responseTypes"
  },
  "form": {
    "submit": "",
    "submitting": ""
  },
  "groups": {
    "edit": "groups.edit",
    "editUsers": "",
    "title": ""
  },
  "IPHIS aktivieren": "IPHIS aktivieren",
  "IPHIS deaktivieren": "IPHIS deaktivieren",
  "not-implemented": "",
  "organizations": {
    "title": ""
  },
  "organizationSelect": {
    "placeholder": ""
  },
  "pageNotFound": {
    "title": ""
  },
  "password": {
    "confirmNewPasswordLabel": "",
    "newPasswordLabel": "",
    "oldPasswordLabel": "",
    "required": "",
    "tooShort": ""
  },
  "planung": {
    "app": "planung.app",
    "enabled": "planung.enabled",
    "solver": "planung.solver",
    "substitution": "planung.substitution",
    "teachingload": "planung.teachingload",
    "timetable": "planung.timetable"
  },
  "Planung aktivieren": "Planung aktivieren",
  "Planung deaktivieren": "Planung deaktivieren",
  "products": {
    "planung": "products.planung"
  },
  "profiles": {
    "create": "",
    "edit": "",
    "onDeleteConfirmText": "",
    "roles": {
      "groups": {
        "add": "",
        "relation": ""
      },
      "profiles": {
        "add": "",
        "relation": ""
      }
    }
  },
  "properties": {
    "add": "",
    "title": ""
  },
  "propertyName": "",
  "propertyScope": "",
  "propertyValue": "",
  "roles": {
    "title": "",
    "type": ""
  },
  "settings": {
    "title": ""
  },
  "shadow": {
    "and": "",
    "conditions": {
      "select": ""
    },
    "optIn": "",
    "or": "",
    "profiles": {
      "add-organization": ""
    },
    "remove": "",
    "shadowProfilesFrom": "shadow.shadowProfilesFrom",
    "shadowProfilesTo": "",
    "shadowsProfilesTo": ""
  },
  "TK-Planung": "TK-Planung",
  "users": {
    "inviteEmailSendSuccessToastText": "users.inviteEmailSendSuccessToastText",
    "title": "users.title"
  },
  "VPO aktivieren": "VPO aktivieren",
  "VPO deaktivieren": "VPO deaktivieren"
}
